import React from 'react';
import { motion } from 'framer-motion';
const WHATSAPP_URL = 'https://wa.me/5491153399780?text=Hola!%20Quiero%20info%20sobre%20el%20Megapack%20Saberes%20Ancestrales%20Latinoam%C3%A9rica%20%F0%9F%8C%BF';
const WhatsAppGlyph = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-428" data-mp="2244vwwa4nik9">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35z" data-id="element-429" data-mp="226henbnplwyd" />
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.27-1.38a9.9 9.9 0 0 0 4.77 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.86 9.86 0 0 0 12.04 2zm0 18.13h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.05-.2-.31a8.22 8.22 0 0 1-1.26-4.36c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.2 8.2 0 0 1 2.41 5.83c0 4.54-3.7 8.22-8.24 8.22z" data-id="element-430" data-mp="2usso7btan87b" />
  </svg>;
export const WhatsAppButton = () => <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Escríbenos por WhatsApp" initial={{
  opacity: 0,
  scale: 0.8
}} animate={{
  opacity: 1,
  scale: 1
}} transition={{
  delay: 1.2,
  type: 'spring',
  stiffness: 300,
  damping: 20
}} whileHover={{
  scale: 1.06
}} whileTap={{
  scale: 0.95
}} className="group fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] transition-colors hover:bg-[#1FBE5A] md:bottom-8 md:right-8 md:px-5 md:py-3.5" data-id="element-431" data-mp="mbcw47rq54ul">
    <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" data-id="element-432" data-mp="371tvn0khl3ys" />
    <WhatsAppGlyph className="h-6 w-6 shrink-0 md:h-7 md:w-7" data-id="element-433" data-mp="e7lkpuzuo4fx" />
    <span className="hidden text-sm font-bold sm:inline md:text-base" data-id="element-434" data-mp="e5s8m06gws0j">
      Escríbenos
    </span>
  </motion.a>;